import { Component, OnInit, ElementRef, Renderer2, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AtpFiltersPanelItem, EventArgs, AtpFiltersPanelGroup, AtpFiltersPanelSelect } from '../../atp-core';
import { FormGroup, FormControl } from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'atp-filters-panel',
  templateUrl: './atp-filters-panel.component.html',
  animations: [
    trigger('OpenClose', [
      state('opened', style({ transform: 'rotate(180deg)' })),
      state('closed', style({ transform: 'rotate(0deg)' })),
      transition('opened => closed', [
        animate('300ms ease-in', style({ transform: 'rotate(360deg)' }))
      ]),
      transition('closed => opened', [
        animate('300ms ease-out')
      ]),
    ]),
  ]
})
export class AtpFiltersPanelComponent implements OnInit {

  constructor(private _elementRef: ElementRef, private _activatedRoute: ActivatedRoute, private _renderer: Renderer2) { }

  @Input() label: string;
  private _prefix: string;
  @Input()
  get prefix(): string {
    return this._prefix;
  }
  set prefix(value: string) {
    if (this._prefix) {
      this._renderer.removeClass(this._elementRef.nativeElement, 'atp-filters-panel_' + value.toLowerCase());
    }
    this._prefix = value;
    if (this._prefix) {
      this._renderer.addClass(this._elementRef.nativeElement, 'atp-filters-panel_' + value.toLowerCase());
    }
  }

  @Input() items: AtpFiltersPanelItem<any>[] = [];
  @Input() isNotExpandable: boolean;
  @Input() filteringButtonLabel: string;
  @Input() clearButtonLabel: string;
  @Input() queryParams: any;

  form: FormGroup;

  @Output('filtrationClick') filtrationEvent = new EventEmitter<EventArgs<AtpFiltersPanelComponent, any>>();
  @Output('resetClick') resetEvent = new EventEmitter<EventArgs<AtpFiltersPanelComponent, any>>();

  getTemplateRef(templateRefs: { [key: string]: TemplateRef<any> }, controlType: string): TemplateRef<any> {
    return templateRefs[controlType];
  }

  private _toggleChanged: boolean = false;
  get toggleChanged(): boolean {
    return this._toggleChanged;
  }
  set toggleChanged(value: boolean) {
    if (!this.isNotExpandable) {
      setTimeout(() => {
        this._toggleChanged = value;
      }, 0);
    }
  }

  ngOnInit() {
    if (this.queryParams) {
      this.fillValues(this.queryParams);
      if (Object.keys(this.queryParams).length) {
        setTimeout(() => {
          this.toggleChanged = true;
        }, 0);
      }
    }
    else {
      this._activatedRoute.queryParams.subscribe(
        data => {
          this.fillValues(data);
          if (Object.getOwnPropertyNames(data).length > 0) {
            setTimeout(() => {
              this.toggleChanged = true;
            }, 0);
          }
        }
      );
    }
  }

  private flatList(): AtpFiltersPanelItem<any>[] {
    let recurs = (items: AtpFiltersPanelItem<any>[], resultList?: AtpFiltersPanelItem<any>[]) => {
      if (!resultList) resultList = [];
      for (const item of items) {
        if (item instanceof AtpFiltersPanelGroup) {
          recurs(item.items, resultList);
        }
        else {
          resultList.push(item);
        }
      }
    };

    let result: AtpFiltersPanelItem<any>[] = [];
    recurs(this.items, result);
    return result;
  }

  private fillValues(values: any) {
    const flatList = this.flatList();
    let form: FormGroup;
    if (!this.form) {
      form = new FormGroup({});
    }

    for (const item of flatList) {
      const formControl = this.form ? this.form.controls[item.name] : new FormControl();
      if (!this.form) {
        formControl.valueChanges.subscribe(
          value => {
            item.value = value;
          }
        );
        form.addControl(item.name, formControl);
      }
      switch (item.type) {
        case 'Boolean':
          formControl.setValue(values[item.name] === undefined ? !!item.value : values[item.name] == 'true');
          break;
        case 'Number':
          formControl.setValue(values[item.name] === undefined ? !item.value && item.value !== 0 ? null : +item.value : !values[item.name] && values[item.name] !== 0 ? null : +values[item.name]);
          break;
        case 'Select':
          formControl.setValue(values[item.name] === undefined ? item.value : (<AtpFiltersPanelSelect>item).options.find(x => values[item.name] == x.id));
          break;
        case 'DateTime':
          let value: Date[] = [];

          value[0] = values[item.name + '_From'] ? new Date(values[item.name + '_From']) : null;
          value[1] = values[item.name + '_To'] ? new Date(values[item.name + '_To']) : null;

          formControl.setValue(value.length ? value : item.value);
          break;
        default:
          formControl.setValue(values[item.name] === undefined ? item.value : values[item.name]);
          break;
      }
    }
    if (!this.form) {
      this.form = form;
    }
  }

  filtrationClick() {
    let result = {};
    const flatList = this.flatList();
    for (const item of flatList) {
      if (item.value != item.defaultValue && (item.type == 'Boolean' || item.value)) {
        switch (item.type) {
          case 'Select':
            result[item.name] = item.value.id;
            break;
          case 'DateTime':
            if (item.value[0]) {
              result[item.name + '_From'] = item.value[0] ? (<Date>item.value[0]).toUTCString() : null;
            }
            if (item.value[1]) {
              result[item.name + '_To'] = item.value[1] ? (<Date>item.value[1]).toUTCString() : null;
            }
            break;
          default:
            result[item.name] = item.value;
            break;
        }
      }
    }

    this.filtrationEvent.emit(new EventArgs(this, result));
  }

  resetClick() {
    const flatList = this.flatList();
    for (const item of flatList) {
      if (item.value != item.defaultValue) {
        item.value = item.defaultValue;
      }
    }

    this.fillValues({});

    this.resetEvent.emit(new EventArgs(this, null));
  }

}
